<div class="column-container" [formGroup]="fg" style="margin-top: 10px;">
    <div class="row-container">
        <mat-form-field  style="width: 50%;">
            <mat-label>Type</mat-label>
            <mat-select [formControlName]="'type'">
                <mat-option *ngFor="let optn of noteType" [value]="optn.type" [disabled]="optn.disabled">{{optn.type}}</mat-option>
            </mat-select>
            <mat-error *ngIf="this.fg.get('type').hasError('required')">Required</mat-error>
        </mat-form-field>
        <mat-form-field style="width: 50%;">
            <mat-label>Title</mat-label>
            <input matInput [formControlName]="'title'" wfdssRemoveSpaceOnly>
            <mat-error *ngIf="this.fg.get('title').hasError('required')">Required</mat-error>
            <mat-error *ngIf="this.fg.get('title').hasError('maxlength')">Title too long: {{this.fg.get('title').value | characterCount}}/100</mat-error>
            <mat-hint *ngIf="this.fg.get('title').valid">{{this.fg.get('title').value | characterCount}}/100</mat-hint>
        </mat-form-field>
    </div>
    <mat-form-field>
        <mat-label>{{label}}</mat-label>
        <wfdss-rte-mat-form-field [formControlName]="'content'"></wfdss-rte-mat-form-field>
        <mat-error *ngIf="this.fg.get('content').hasError('required')">Required</mat-error>
    </mat-form-field>
    <div class="row-container" *ngIf="!this.noteReadonly">
        <button (click)="onSave()" class="primary-button" [disabled]="disableSave || !fg.dirty">{{saveText}}</button>
        <button (click)="onCancel()" class="primary-button" [disabled]="noteReadonly || !fg.dirty">Cancel</button>
    </div>
</div>